// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__nknmi","container":"SectionHeader_container__fgj93","header__heading":"SectionHeader_header__heading__6Hetc"};